// extracted by mini-css-extract-plugin
export default {"TableRoot":"table_TableRoot__dgHUY"};